import _ from 'underscore';
import URI from 'urijs';

const pathAndBasenameFormatted = (pathname, basename) => {
  const format = {
    pathname: {
      value: pathname,
      isValid: _.isString(pathname),
    },
    basename: {
      value: basename,
      isValid: _.isString(basename),
    },
  };

  if (format.pathname.isValid && format.basename.isValid) {
    const getUriProperties = (path) => {
      const uri = URI(path);
      const isRelative = uri.is('relative');
      const segments = uri.segment();
      const segmentsLowerCase = _.map(segments, s => s.toLowerCase());
      return {
        uri,
        isRelative,
        segments,
        segmentsLowerCase,
      };
    };

    _.extend(format.pathname, getUriProperties(pathname));
    _.extend(format.basename, getUriProperties(basename));
    format.isPathStartWithbasename = format.pathname.isRelative && _.isEqual(
      format.pathname.segmentsLowerCase.slice(0, format.basename.segmentsLowerCase.length),
      format.basename.segmentsLowerCase
    );
  }

  return format;
};

/**
 * Remove the basename from the relative path
 * @param {String} pathname The string value of a URL's path
 * @param {String} basename The string value of the site basename (between hostname and spa routing starting point)
 * @returns {String} The SPA path without basename if exists, the pathname otherwise. In case pathname is not a string, returns null
 */
export const removeBasename = (pathname, basename) => {
  const format = pathAndBasenameFormatted(pathname, basename);
  if (!format.pathname.isValid) {
    return null;
  }
  if (!format.basename.isValid) {
    return pathname;
  }
  if (format.isPathStartWithbasename) {
    const segmentWithoutBasename = format.pathname.segments.slice(format.basename.segments.length);
    return format.pathname.uri.segment(segmentWithoutBasename).toString();
  }
  return pathname;
};

/**
 * Add the basename from the path (if relative)
 * @param {String} pathname The string value of a URL's path
 * @param {String} basename The string value of the site basename (between hostname and spa routing starting point)
 * @returns {String} The full relative path with basename if relative, the same pathname otherwise. In case pathname is not a string, returns null
 */
export const addBasename = (pathname, basename) => {
  const format = pathAndBasenameFormatted(pathname, basename);
  if (!format.pathname.isValid) {
    return null;
  }
  if (!format.basename.isValid) {
    return pathname;
  }
  if (format.pathname.isRelative && !format.isPathStartWithbasename) {
    return format.pathname.uri.segment([...format.basename.segments, ...format.pathname.segments]).toString();
  }
  return pathname;
};
